import ErrorTwoToneIcon from '@mui/icons-material/ErrorTwoTone';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
const TRANS_NS = 'page-error';

export const NotFoundError = () => {
  const { t } = useTranslation(TRANS_NS);
  return (
    <Box
      height={'100%'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      gap={2}
    >
      <ErrorTwoToneIcon color={'primary'} sx={{ fontSize: 64 }} />
      <Typography variant={'h1'}>{t('notFound.title')}</Typography>
      <Button component={Link} to={'/'} variant={'contained'}>
        {t('notFound.action')}
      </Button>
    </Box>
  );
};
